import { XIcon } from '@primer/octicons-react';
import { clsx } from 'clsx';
import { defaultTokenSize, tokenSizes } from './TokenBase.js';
import classes from './_RemoveTokenButton.module.css.js';
import { jsx } from 'react/jsx-runtime';

const getTokenButtonIconSize = size => parseInt(tokenSizes[size || defaultTokenSize], 10) * 0.75;
const RemoveTokenButton = ({
  'aria-label': ariaLabel,
  isParentInteractive,
  size = defaultTokenSize,
  className,
  borderOffset = 0,
  as: _as,
  ...rest
}) => {
  // eslint-disable-next-line react-compiler/react-compiler
  delete rest.children;
  if (isParentInteractive) {
    return /*#__PURE__*/jsx("span", {
      ...rest,
      tabIndex: -1,
      "aria-label": ariaLabel,
      "data-size": size,
      className: clsx(classes.TokenButton, className),
      style: {
        transform: `translate(${borderOffset}px, -${borderOffset}px)`
      },
      children: /*#__PURE__*/jsx(XIcon, {
        size: getTokenButtonIconSize(size)
      })
    });
  }
  return /*#__PURE__*/jsx("button", {
    ...rest,
    "aria-label": 'Remove token',
    "data-size": size,
    className: clsx(classes.TokenButton, className),
    style: {
      transform: `translate(${borderOffset}px, -${borderOffset}px)`
    },
    ref: rest.ref,
    type: "button",
    children: /*#__PURE__*/jsx(XIcon, {
      size: getTokenButtonIconSize(size)
    })
  });
};
RemoveTokenButton.displayName = "RemoveTokenButton";

export { RemoveTokenButton as default };
